/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth } from "../auth/AuthProvider";

function AdminSidebar() {
  const { roles } = useAuth();

  return (
    <List>
      {roles.includes("admin") && (
        <ListItem button component={Link} to="/admin/users">
          <ListItemText primary="Manage Users" />
        </ListItem>
      )}
      {(roles.includes("admin") || roles.includes("reviewer")) && (
        <ListItem button component={Link} to="/admin/invites">
          <ListItemText primary="Pending Invites" />
        </ListItem>
      )}
      {roles.includes("admin") && (
        <ListItem button component={Link} to="/admin/roles">
          <ListItemText primary="Role Reference" />
        </ListItem>
      )}
    </List>
  );
}

export default AdminSidebar;
